import Component from "@tunnel-components/@pages/lapi-tmd/explorer/component";
import * as React from "react";
import { connect } from "react-redux";
import * as Lodash from "lodash";
import * as moment from "moment";
import {
  LapiAndTmpLoadedActionCreator,
  CameraLapiTmdLoadedActionCreator,
  ExtrairePdfTmdActionCreator,
  FilterIncidentTmdActionCreator,
} from "@tunnel-store/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @property { object }      state
     */
    this.state = {
      laPiData: [],
      arrayOfIncident: [],
      filter: [false, false, false, false, false, false, false],
      totalElements: 2,
      itemsPerPage: 500,
      fiterInfos: "",
      noIncidents: false,
      startDate: "",
      endDate: "",
      paramArray: 0,
      cameraString: "",
      currentPageNumbers: 1,
      sorting: "direction=DESC&orderBy=insertedAt",
      isFilter: false,
      onpensearchboolean: false,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onOpen = this.onOpen.bind(this); // ouverture
    this.onOpenhoverCard = this.onOpenhoverCard.bind(this); // ouverture
    this.onClosehoverCard = this.onClosehoverCard.bind(this); // fermeture
    this.onClose = this.onClose.bind(this); //
    this.onIncidentActif = this.onIncidentActif.bind(this);
    this.onIncidentActifOut = this.onIncidentActifOut.bind(this);
    this.onSortingBy = this.onSortingBy.bind(this);
    this.onUpdateCurrentPageNumber = this.onUpdateCurrentPageNumber.bind(this); // fonction de mise à jour de la page courante

    this.onFilter = this.onFilter.bind(this);
    this.onReset = this.onReset.bind(this);
    this.onPenSearchIncidents = this.onPenSearchIncidents.bind(this);

    this.onExplorerSearch = this.onExplorerSearch.bind(this);
    this.onExplorerSearchChange = this.onExplorerSearchChange.bind(this);

    this.onSearchSubmitFilter = this.onSearchSubmitFilter.bind(this);
    this.onStartDateChange = this.onStartDateChange.bind(this);
    this.onEndDateChange = this.onEndDateChange.bind(this);
    this.onGetValue = this.onGetValue.bind(this);
    this.onExtractPdf = this.onExtractPdf.bind(this);
    this.onExtractPdfAll = this.onExtractPdfAll.bind(this);

    this.onClearIncidentSearch = this.onClearIncidentSearch.bind(this);
  }

  /**
   * @method onClearIncidentSearch
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onClearIncidentSearch = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.props
      .LapiAndTmpLoadedActionCreator(
        this.state.currentPageNumbers - 1,
        this.state.itemsPerPage,
        "direction=DESC&orderBy=insertedAt"
      )
      .then(() =>
        this.setState((state: any): any => ({
          explorersearch: "",
          fiterInfos: "",
          noIncidents: false,
          sorting: "direction=DESC&orderBy=insertedAt",
          onresetoff: false,
          onresetSuccess: false,
        }))
      );
  };
  /**
   * Extraire l'incident au format pdf
   * @public
   * @method
   * @name onExtractPdf
   * @param { number } param
   * @param { number } index
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onExtractPdf = (param: number, index: number) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    // event.preventDefault();

    this.setState((state: any): any => ({
      errorExtractionPdf: false,
      loading: true,
    }));

    {
      /** appel de l'action */
    }
    this.props
      .ExtrairePdfTmdActionCreator(param)
      .then(() => this.setState((state: any): any => ({ loading: false })));
  };
  /**
   * Extraire l'incident au format pdf
   * @public
   * @method
   * @name onExtractPdfAll
   * @param { number } param
   * @param { number } index
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onExtractPdfAll = (action: string) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    // event.preventDefault();

    this.setState((state: any): any => ({
      errorExtractionPdf: false,
      loading: true,
    }));

    {
      /** appel de l'action */
    }
    this.props
      .FilterIncidentTmdActionCreator(
        this.state.currentPageNumbers - 1,
        this.state.itemsPerPage,
        this.state.sorting
      )
      .then(() => this.setState((state: any): any => ({ loading: false })));
  };

  /**
   * @method onPenSearchIncidents
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onPenSearchIncidents = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      onpensearchboolean: !this.state.onpensearchboolean,
    }));
  };

  /**
   * Choisir un incident
   * @public
   * @method
   * @name onIncidentActif
   * @param { any } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onIncidentActif = (param: any) => (event: any) => {
    /**
     * @constant
     * @name arrayOfIncident
     * @type any[]
     */
    const arrayOfIncident: any[] = [];

    const paramArray: number = param;

    if (!Lodash.isEmpty(this.state.arrayOfIncident)) {
      {
        /**  test du type ou existance du paramètre */
      }
      for (let i = 0; i < Math.ceil(this.state.arrayOfIncident.length); i++) {
        arrayOfIncident.push(false);
      }

      arrayOfIncident[param] = true;

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ arrayOfIncident, paramArray }));
    }
  };
  /**
   * Choisir un incident
   * @public
   * @method
   * @name onIncidentActifOut
   * @param { any } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onIncidentActifOut = (event: any) => {
    /**
     * @constant
     * @name arrayOfIncident
     * @type any[]
     */
    const arrayOfIncident: any[] = [];

    if (!Lodash.isEmpty(this.state.arrayOfIncident)) {
      {
        /**  test du type ou existance du paramètre */
      }
      for (let i = 0; i < Math.ceil(this.state.arrayOfIncident.length); i++) {
        arrayOfIncident.push(false);
      }

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ arrayOfIncident }));
    }
  };

  /**
   * @method onUpdateCurrentPageNumber
   * @description: MAJ de la page courante
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onUpdateCurrentPageNumber = (target: any) =>
    this.setState((state: any) => ({ currentPageNumbers: Number(target) }));
  /**
   * @method onOpenhoverCard
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onOpenhoverCard = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      errorvideo: false,
      openHoverCard: true,
    }));
  };
  /**
   * @method onClosehoverCard
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onClosehoverCard = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      errorvideo: false,
      openHoverCard: false,
    }));
  };
  /**
   * Activation front des tri
   * @method onOpen
   * @param {number } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onOpen = (param: number) => (event: any): void => {
    /**
     * @constant
     * @name filter
     * @type any[]
     */
    const filter: any[] = [];

    {
      /** boucle */
    }
    for (let i = 0; i < Math.ceil(this.state.filter); i++) {
      filter.push(false);
    }

    filter[param] = true;

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ filter }));
  };
  /**
   * Changement de l'etat de l'onglet
   * @public
   * @method
   * @name onClose
   * @param { any }  event
   * @infos "https://reactjs.org"
   */
  public onClose = (event: any): void => {
    /**
     * @constant
     * @name filter
     * @type any[]
     */
    const filter: any[] = [];

    {
      /** boucle */
    }
    for (let i = 0; i < Math.ceil(this.state.filter); i++) {
      filter.push(false);
    }

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ filter }));
  };
  /**
   * Triage par ordre alphanumérique / date
   * @method onSortingBy
   * @param {number } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSortingBy = (action: any) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    const filter: any[] = [false, false, false, false, false, false, false];
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      filter,
      sorting: action + this.state.fiterInfos,
    }));
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ loading: true }));
    this.props.CameraLapiTmdLoadedActionCreator(); // Chargement de la liste des caméras
    // this.props.ExtractorCameraListActionCreator(); // Chargement de la liste des caméras
    {
      /** Action creator */
    }
    this.props
      .LapiAndTmpLoadedActionCreator(
        this.state.currentPageNumbers - 1,
        this.state.itemsPerPage,
        this.state.sorting
      )
      .then(() => this.setState((state: any): any => ({ loading: false })));
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** vérification de l'existence de l'élement  */
    }
    if (prevState.currentPageNumbers !== this.state.currentPageNumbers) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ loading: true }));
      {
        /** Action creator */
      }
      this.props
        .LapiAndTmpLoadedActionCreator(
          this.state.currentPageNumbers - 1,
          this.state.itemsPerPage,
          this.state.sorting
        )
        .then(() => this.setState((state: any): any => ({ loading: false })));
    } else if (prevProps.data !== this.props.data) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(this.props.data)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          laPiData: this.props.data.content,
          totalElements: this.props.data.totalElements,
        }));
        {
          /** vérification de l'existence de l'élement  */
        }
        if (this.props.data.content.length === 0) {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            noIncidents: true,
            errorserver: false,
          }));
        }
      }
    } else if (prevState.sorting !== this.state.sorting) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ loading: true }));
      {
        /** Action creator */
      }
      this.props
        .LapiAndTmpLoadedActionCreator(
          0,
          this.state.itemsPerPage,
          this.state.sorting
        )
        .then(() =>
          this.setState((state: any): any => ({
            currentPageNumbers: 1,
            loading: false,
          }))
        );
    }
  }
  // des anciennes méthodes
  /**
   * Manipulation des données et changement de l'etat de l'onglet
   * date, caméra, ....
   * @public
   * @method onReset
   * @param { any }  event
   * @param { string }  action
   * @infos "https://reactjs.org"
   */
  public onReset = (action: string) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    // this.setState((state: any):any =>({loading: true}));
    //  this.props.LapiAndTmpLoadedActionCreator(0,this.state.itemsPerPage,"direction=DESC&orderBy=insertedAt")
    // .then( () => )
    this.setState((state: any) => ({
      loading: false,
      cameraString: "",
      currentPageNumbers: 1,
      startDate: "",
      fiterInfos: "",
      endDate: "",
      explorersearch: "",
      noIncidents: false,
      onresetoff: false,
      onresetSuccess: false,
      sorting: action,
    }));
  };
  /**
   * Modification de l'état du filtre
   * @public
   * @method onFilter
   * @param { any }  event
   * @infos "https://reactjs.org"
   */
  public onFilter = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ isFilter: !this.state.isFilter }));
    // this.onCleanFilter();
    {
      /** Empêcher la mutation du state */
    }
    // this.setState((state: any):any =>({errorDateRange:false, onresetSuccess:false,openHoverCard:false,noIncidents:false,}))
  };

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** comparaison */
    }
    if (nextProps.error !== this.props.error) {
      {
        /** vérification de l'existance */
      }
      if (!Lodash.isUndefined(nextProps.error)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          errorserver: true,
          errorExtractionPdf: false,
        }));
      }
    } else if (nextProps.errorAllpdf !== this.props.errorAllpdf) {
      {
        /** vérification de l'existance */
      }
      if (!Lodash.isUndefined(nextProps.errorAllpdf)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ errorExtractionPdf: true }));
      }
    } else if (nextProps.errorIncidentPdf !== this.props.errorIncidentPdf) {
      {
        /** vérification de l'existance */
      }
      if (!Lodash.isUndefined(nextProps.errorIncidentPdf)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ errorExtractionPdf: true }));
      }
    } else if (nextProps.data !== this.props.data) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.data)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          laPiData: nextProps.data.content,
          totalElements: nextProps.data.totalElements,
        }));
        {
          /** vérification de l'existence de l'élement  */
        }
        if (nextProps.data.content.length === 0) {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            noIncidents: true,
            errorserver: false,
          }));
        }
        /**
         * @constant
         * @name arrayOfIncident
         * @type any[]
         */
        const arrayOfIncident: any[] = [];

        {
          /**  test du type ou existance du paramètre */
        }
        for (let i = 0; i < Math.ceil(nextProps.data.content.length); i++) {
          arrayOfIncident.push(false);
        }

        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ arrayOfIncident }));
      }
    }
  }
  /**
   * @method onExplorerSearchChange
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onExplorerSearchChange = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ [event.target.name]: event.target.value });
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      errorSearchIncident: false,
      onresetoff: false,
      onresetSuccess: false,
    }));
  };
  /**
   * @method onExplorerSearch
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onExplorerSearch = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }

    this.setState((state: any): any => ({ loading: true }));
    if (typeof this.state.explorersearch !== undefined) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        sorting: "plate=" + String(this.state.explorersearch).toUpperCase(),
        fiterInfos: "&plate=" + String(this.state.explorersearch).toUpperCase(),
        loading: false,
      }));
    }
  };
  /**
   * Cette méthode mute le state
   * @action " Changement  "
   * @method
   * @name onSearchSubmitFilter
   * @param { any }  event
   * @return { void }
   */
  public onSearchSubmitFilter = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      errorDateRange: false,
      noIncidents: false,
    }));
    /**
     * @constant
     * @name minDate
     * @type Date
     */
    const minDate: any = moment(this.state.startDate).format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    /**
     * @constant
     * @name maxDate
     * @type Date
     */
    const maxDate: any = moment(this.state.endDate).format(
      "YYYY-MM-DDTHH:mm:ss"
    );

    /**
     * @constant
     * @name action
     * @type string
     */
    let action: string = "";

    if (
      !Lodash.isEqual(minDate, "Invalid date") &&
      !Lodash.isEqual(maxDate, "Invalid date")
    ) {
      if (minDate >= maxDate) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ errorDateRange: true }));
      } else {
        this.setState((state: any): any => ({ loading: true }));

        if (this.state.cameraString === "") {
          action = "startDate=" + minDate + "&endDate=" + maxDate;
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            isFilter: false,
            loading: false,
            noSearchById: true,
            sorting: action,
            fiterInfos: "&" + action,
          }));
        } else {
          action =
            "startDate=" +
            minDate +
            "&endDate=" +
            maxDate +
            "&" +
            this.state.cameraString;
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            isFilter: false,
            loading: false,
            noSearchById: true,
            sorting: action,
            fiterInfos: "&" + action,
          }));
        }
      }
    } else if (
      Lodash.isEqual(minDate, "Invalid date") &&
      !Lodash.isEqual(maxDate, "Invalid date")
    ) {
      {
        /** Empêcher la mutation du state */
      }

      if (this.state.cameraString === "") {
        action = "endDate=" + maxDate;
        this.setState((state: any): any => ({ loading: true }));
        this.setState((state: any): any => ({
          isFilter: false,
          noIncidents: false,
          noSearchById: true,
          loading: false,
          onresetoff: false,
          onresetSuccess: false,
          sorting: action,
          fiterInfos: "&" + action,
        }));
      } else {
        this.setState((state: any): any => ({ loading: true }));
        action = "endDate=" + maxDate + "&" + this.state.cameraString;
        this.setState((state: any): any => ({
          isFilter: false,
          noIncidents: false,
          noSearchById: true,
          loading: false,
          onresetoff: false,
          onresetSuccess: false,
          sorting: action,
          fiterInfos: "&" + action,
        }));
      }
    } else {
      if (this.state.cameraString === "") {
        this.setState((state: any): any => ({ loading: true }));
        this.setState((state: any): any => ({
          isFilter: false,
          noIncidents: false,
          noSearchById: true,
          loading: false,
          onresetoff: false,
          onresetSuccess: false,
          sorting: "direction=DESC&orderBy=insertedAt",
          fiterInfos: "",
        }));
      } else {
        this.setState((state: any): any => ({ loading: true }));
        action = this.state.cameraString;
        this.setState((state: any): any => ({
          isFilter: false,
          noIncidents: false,
          noSearchById: true,
          loading: false,
          onresetoff: false,
          onresetSuccess: false,
          sorting: action,
          fiterInfos: "&" + action,
        }));
      }
    }
  };
  /**
   * Changement des date avec le date picker
   * @external { react-datepicker }
   * @public
   * @method onStartDateChange
   * @param { any } value
   * @infos "https://reactjs.org"
   */
  public onStartDateChange(value: any) {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      startDate: value,
      errorDateRange: false,
      noSearchById: true,
      onresetoff: false,
      onresetSuccess: false,
      noIncidents: false,
    }));
  }
  /**
   * Changement des date avec le date picker
   * @external { react-datepicker }
   * @public
   * @method
   * @name onEndDateChange
   * @param { any } value
   * @infos "https://reactjs.org"
   */
  public onEndDateChange(value: any) {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      endDate: value,
      errorDateRange: false,
      noSearchById: true,
      onresetoff: false,
      onresetSuccess: false,
      noIncidents: false,
    }));
  }
  /**
   * Manipulation des données et changement de l'etat de l'onglet
   * caméra ....
   * @public
   * @method
   * @name onGetValue
   * @param { string }  param
   * @param { number }  index
   * @param { any }  value
   * @infos "https://reactjs.org"
   */
  public onGetValue = (value: any): void => {
    {
      /** Vérification de la variable */
    }

    if (!Lodash.isEmpty(value) && !Lodash.isUndefined(value)) {
      /**
       * @constant
       * @name valueString
       */
      const valueString: string = "cameraName=" + value;

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ cameraString: valueString }));
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ cameraString: "" }));
    }

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      loading: false,
      noIncidents: false,
      noSearchById: true,
      onresetoff: false,
      onresetSuccess: false,
      errorSearchIncident: false,
      errorDateRange: false,
      selectedValueName: "someEffect",
    }));
  };

  /**
   * Cycle de vie d'un composant react LapiAndTmpLoadedActionCreator
   * @method render
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        onOpen={this.onOpen}
        onOpenhoverCard={this.onOpenhoverCard} // ouverture
        onClosehoverCard={this.onClosehoverCard} // fermeture
        onUpdateCurrentPageNumber={this.onUpdateCurrentPageNumber} //
        onClose={this.onClose}
        onSortingBy={this.onSortingBy}
        onIncidentActif={this.onIncidentActif}
        onIncidentActifOut={this.onIncidentActifOut}
        onReset={this.onReset}
        onFilter={this.onFilter}
        onPenSearchIncidents={this.onPenSearchIncidents}
        onExplorerSearch={this.onExplorerSearch}
        onExplorerSearchChange={this.onExplorerSearchChange}
        onSearchSubmitFilter={this.onSearchSubmitFilter}
        onStartDateChange={this.onStartDateChange}
        onEndDateChange={this.onEndDateChange}
        onGetValue={this.onGetValue}
        onExtractPdf={this.onExtractPdf}
        onExtractPdfAll={this.onExtractPdfAll}
        onClearIncidentSearch={this.onClearIncidentSearch}
        {...this.props}
        {...this.state}
      />
    );
  }
}

/**
 * @function mapStateToProps
 * @param { any } state
 * @return { object }
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  return {
    data: state.LapiAndTmpLoaded.data,
    datacameralist: state.CameraLapiTmdLoaded.data,
    error: state.LapiAndTmpLoaded.error,
    errorAllpdf: state.FilterIncidentTmd.error,
    errorIncidentPdf: state.ExtrairePdfTmd.error,
  };
}

/** @export HOC connect */
export default connect(mapStateToProps, {
  LapiAndTmpLoadedActionCreator,
  ExtrairePdfTmdActionCreator,
  FilterIncidentTmdActionCreator,
  CameraLapiTmdLoadedActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/lapi-tmd/explorer/container.tsx